module.exports = __webpack_public_path__ + "static/media/lds-logo_nl.21409a17.svg";